import './App.css';
import Home from './sections';
import Footer from './sections/Footer';
function App() {
  return (
    <div className='App'>
      <Home/>
      <Footer />
    </div>
  );
}

export default App;
